import { useParams } from "react-router-dom";
import FormularioCategoria from "./FormularioCategoria";
import { useEffect, useState } from "react";
import { Categoria } from "../DTO/Categoria";
import { useCategoriaStore } from "../store/CategoriaStore";
import toast from "react-hot-toast";
import { globalApiError } from "../utils/generalApiError";
import LoadingModal from "../elementos/LoadingModal";

const EditarCategoria = () => {
  const id = useParams().id ?? null;
  const { obtenerCategoriabyId } = useCategoriaStore();
  const [categoria, setCategoria] = useState<Categoria | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategoria = async () => {
      try {
        const response = await obtenerCategoriabyId(id);
        setCategoria(response);
      } catch (error) {
        toast.error(globalApiError(error));
      } finally {
        setLoading(false);
      }
    };

    fetchCategoria();
  }, [id]);


  return (
    <div>
      <LoadingModal show={loading} message="Cargando categoría..." />
      <div className="container mt-4">
        <h1 className="text-center mb-4">Agregar Nueva Categoria</h1>
        <FormularioCategoria id={id} categoria={categoria} />
      </div>
    </div>
  );
};

export default EditarCategoria;
